import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_PAGE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deletePage($input: DeletePageInput!) {
    deletePage(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
